export const check = Boolean;

export const required = {
    check,
    getMessage: () => "This field is required",
};

